import _ from 'lodash';

import { mapGetters } from 'vuex';

import assetsManagerFactory from '_/vuex/modules/assetsManager';
import { store } from '_/vuex/store';

/**
 * Base test data
 *
 * @type  {Object}
 */
const baseTestData = {
    defaultValue: false,
    disabled: false,
    id: 71,
    name: 'testName',
    value: null,
    label: 'Test Label',
    mutation: 'testing/DEFAULT_TEST_MUTATION',
    tooltip: 'Testing the Tooltip.',
    vueComponent: 'RichText',
};

export default {
    data() {
        return {
            /**
             * An object sent to child components; used to signal that the fields need to be reset, with the ability
             * to limit the reset to only certain fields
             *
             * @type  {Object}
             */
            formFieldsReset: {
                /**
                 * A list of field names to include in a reset action
                 *
                 * @type  {Array}
                 */
                includeFields: [],

                /**
                 * A parameter that is listened by the child components. Changed via moment().valueOf() method to always
                 * set the fresh value.
                 *
                 * @type  {integer}
                 */
                resetData: null,
            },

            assetsManagerDynamicModuleName: '',

            /**
             * Tests
             *
             * @type  {Object}
             */
            tests: {
                testDefaultSettings: {
                    ...baseTestData,
                },

                testDisabled: {
                    ...baseTestData,
                    disabled: true,
                },

                testValue: {
                    ...baseTestData,
                    value: '<p>test value</p>',
                },

                testDefaultValue: {
                    ...baseTestData,
                    defaultValue: '<p>test value</p>',
                },
            },

            /**
             * Selected test data
             *
             * @type  {Object}
             */
            test: {},
        };
    },

    /**
     * Set the computed property
     *
     * @type  {Object}
     */
    computed: {
        ...mapGetters({
            testingState: 'testing/testing',
        }),

        /**
         * Toggles the tested component
         *
         * @return  {boolean}
         */
        showComponent() {
            return !_.isEmpty(this.test);
        },
    },

    beforeCreate() {},

    /**
     * Set the mounted hook
     *
     * @return  {void}
     */
    mounted() {
        this.test = this.tests[this.$route.params.test];

        const assetsManagerDynamicModuleName = `assetsManager-testName-71`;

        if (!_.has(store.state, assetsManagerDynamicModuleName)) {
            store.registerModule(assetsManagerDynamicModuleName, assetsManagerFactory(assetsManagerDynamicModuleName));
        }
    },

    created() {},
};
